export default __webpack_public_path__ + "static/media/icon-washing-machine.bf9c4384.svg";